<template>
<div class="main-page-calling" v-resize="calcalteGridMode">
    <!-- COMMENT calling -->
    <div class="layout-calling">
        <!-- COMMENT main user -->
        <div :class="`layout-user-grid list`">
            <!-- <div :class="`layout-user-grid ${!control.display ? 'grid' : 'list'}`"> -->
            <!-- // COMMENT เมื่อใช้งาน List Mode จะเเสดงแต่ user ที่เลือกเท่านั้นแต่สามารถ สลับได้ -->
            <div class="user-grid-display" v-show="!stateSharedBtn" :style="`grid-template-columns: repeat(1, 1fr);grid-template-rows: repeat(1, 1fr);`">
                <div v-for="i in users" :key="`item-${i.uid}`" class="items" v-show="i.uid == mainUid">
                    <!-- ตัวเอง -->
                    <u-user-stream :id="`${i.uid}`" :title="`${i.uid}`" :camera="i.camera" :microphone="i.microphone" v-if="i.uid == mainUid" :checkMainUser="'MainDisplay'"/>
                </div>
            </div>

            <!-- COMMENT list user -->
            <div :class="`layout-user-list mt-1`" :style="`${!control.screen ? ' height:47%;' : 'height: 80%;'}`">
                <!-- <div :class="`layout-user-list ${!control.display ? 'layout-user-list-non-display' : 'layout-user-list-display'}`"> -->
                <!-- <div class="layout-user-list"> -->
                <!-- แถว list ผู้เข้าประชุม -->
                <div class="user-list">
                    <!-- <div class="user-list pa-3 blue-grey"> -->
                    <!-- กรอบแต่ละ Usser ของคนอื่น -->
                    <div v-for="i in users" :key="`item-${i.uid}`" class="items" v-show="i.uid != mainUid" :style="`${setRole ? ' width:46%;' : 'width: 22%;'}`">
                        <!-- carmera -->
                        <!-- คนอื่น -->
                        <div class="item-content m-5" @click="clickSwapUser(i.uid)" v-if="i.uid">
                            <u-user-stream :id="`${i.uid}`" :title="`${i.uid}`" :camera="i.camera" :microphone="i.microphone" />
                        </div>
                        <!-- {{i.uid}} ,{{i.camera}},{{i.microphone}} -->
                        <div class="display-state-user-list" v-if="i.uid != mainUid">
                            <div class="state-btn-user-list">
                                <v-icon v-if="i.camera" size="24" color="#fff">mdi-video</v-icon>
                                <v-icon v-else size="24" color="#fff">mdi-video-off</v-icon>
                            </div>
                            <div class="state-btn-user-list">
                                <v-icon v-if="i.microphone" size="24" color="#fff">mdi-microphone</v-icon>
                                <v-icon v-else size="24" color="#fff">mdi-microphone-off</v-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- COMMENT control -->
            <div class="layout-control">
                <u-user-control v-model="control"
                  :channel="credential.channel"
                  :disableDisplayBtn="disableDisplayBtn"
                  :disableRecordBtn="disableRecordBtn"
                  :disableCameraBtn="disableCameraBtn"
                  :disableMicrophoneBtn="disableMicrophoneBtn"
                  :disableSharedScreenBtn="disableSharedScreenBtn"
                  :disableEndingBtn="disableEndingBtn"
                  :disableChatBtn="disableChatBtn"
                  @clickDisplayBtn="ClickDisplayBtn"
                  @clickRecordBtn="ClickRecordBtn"
                  @clickCameraBtn="ClickCameraBtn"
                  @clickMicrophoneBtn="ClickMicrophoneBtn"
                  @clickEndingBtn="ClickEndingBtn(credential.channel)"
                >
                    <template v-slot:options>
                         <!-- <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <div v-on="on" class="d-inline-block"> -->
                              <v-btn text @click="ClickSharedScreenBtn(control)" dark icon rounded width="32" height="32" :style="`${stateSharedBtn ? ' background: white;' : 'background: #FF1744;'}` ">
                                <v-icon v-if="stateSharedBtn" small color="#20409C">mdi-monitor-share</v-icon>
                                <v-icon v-else color="white" small>mdi-monitor-off</v-icon>
                              </v-btn>
                            <!-- </div>
                          </template>
                          <span v-if="stateSharedBtn">แชร์หน้าจอ</span>
                          <span v-else>ปิดแชร์หน้าจอ</span>
                        </v-tooltip> -->
                          <!-- <v-btn text @click="ClickSharedScreenBtn(control)" dark icon rounded width="32" height="32" :style="`${stateSharedBtn ? ' background: white;' : 'background: #FF1744;'}` ">
                            <v-icon v-if="stateSharedBtn" small color="#20409C">mdi-monitor-share</v-icon>
                            <v-icon v-else color="white" small>mdi-monitor-off</v-icon>
                          </v-btn> -->

                        <v-btn text v-if="displayInvitedToMeetingBtn" @click="getListofConference" dark icon rounded class="white ml-2" width="32" height="32">
                            <v-icon color="#20409C">mdi-account-plus</v-icon>
                        </v-btn>
                    </template>
                </u-user-control>
            </div>
        </div>
    </div>
    <!-- COMMENT control -->

    <!-- COMMENT List Of Conference Dialog -->
    <v-dialog v-model="dialogListConference" persistent max-width="524px" class="layout-dialog-conference">
        <v-card class="mx-auto" style="border-radius: 12px;">
            <v-card-title class="d-flex justify-space-between">
                <div style="font-weight: 700; font-size: 20px; color: #20409C;">
                    รายชื่อ Consult
                </div>
                <div>
                  <v-btn icon dark @click="Close" color="#C4C4C4">
                      <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
            </v-card-title>

            <v-card-text class="pb-1">
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center" style="font-weight: 600; font-size: 16px; color: #333333;">
                  <div class="size-image-icon">
                    <v-img
                      contain
                      :src="require('@/assets/images/conference/titleNameConference.jpg')"
                    />
                  </div>
                  <div>
                      เลือกรายชื่อ Consult
                  </div>
                </div>
                <div>
                    จำนวน :
                    {{countCheckListConference}}
                     คน
                  </div>
                </div>
            </v-card-text>
            <!-- <v-divider class="my-3 mx-5"></v-divider> -->

            <v-card-text>
                <div class="ma-1 list-content-card">
                    <!-- <v-text-field
                        v-show="itemsConsult.length >0 && !loadingItemsConsult"
                        v-model="searchItemsConsult"
                        outlined
                        class="my-1"
                        style="width: 50%;"
                        dense
                        append-icon="mdi-magnify"
                        placeholder="ค้นหา"
                        hide-details
                        color="red"
                        rounded
                      ></v-text-field> -->
                  <div class="search-container">
                    <input type="text" class="search-input"
                      v-show="itemsConsult.length >0 && !loadingItemsConsult"
                      v-model="searchItemsConsult"
                      placeholder="ค้นหา">
                </div>
                  <v-divider class="my-3 mx-5"></v-divider>
                    <div v-for="item in filteredList" :key="item.user_id" class="consult-user">
                        <div class="d-flex align-center">
                          <div style="height: 48px; width: 48px;">
                            <!-- <v-badge bordered overlap location="end" color="success"> -->
                                <v-avatar color="primary">
                                    <span v-if="item.image === ''" class="white--text text-h7 text-uppercase">
                                        {{ item.first_name.charAt(0) }}{{ item.last_name.charAt(0) }}
                                    </span>
                                    <v-img v-else :src="profileUrl(item.image)"></v-img>
                                </v-avatar>
                            <!-- </v-badge> -->
                        </div>
                        <div class="text-consult">
                            <span class="pr-3">{{item.first_name}}</span>
                            <span>{{item.last_name}}</span>
                        </div>
                        </div>
                        <div class="text-consult-role">
                            <v-checkbox v-model="item.stateConsult"></v-checkbox>
                            <!-- {{item.stateConsult}} -->
                        </div>
                    </div>
                </div>
                <div id="loader" v-show="loadingItemsConsult">
                  <!-- <div class="skeleton-card"></div> -->
                  <v-progress-linear
                    color="primary"
                    buffer-value="0"
                    stream
                  ></v-progress-linear>
                </div>
                <div class="no-user-online" v-show="itemsConsult.length <=0 && !loadingItemsConsult">
                    ไม่พบรายชื่อ ผู้ใช้งานที่ทำการออนไลน์ในระบบ
                </div>
            </v-card-text>

            <div class="d-flex justify-center pb-5">
                <v-btn class="btn-invited-meeting-close mr-5" rounded @click="Close">
                    ยกเลิก
                </v-btn>
                <v-btn color="#20409C" class="btn-invited-meeting" rounded @click="invitedToMeeting" v-if="itemsConsult.length > 0">
                    <v-icon class="pr-1" color="white">mdi-send</v-icon>ส่งคำขอ
                </v-btn>
            </div>
        </v-card>
    </v-dialog>

    <!-- COMMENT Layout Dialog -->
    <u-action-dialog v-model="dialog" persistent title="ข้อมูลเพิ่มเติม">
        <template v-slot:content>
            <div class="d-flex">
                แชร์ลิ้งก์การประชุมนี้ <v-spacer></v-spacer>
                <v-btn text small color="primary" @click="copyText">คัดลอก</v-btn><input hidden type="text" :value="link" id="copy-shared-url" />
            </div>
        </template>
    </u-action-dialog>

    <!-- COMMENT AUDIO -->
    <audio id="myAudio" hidden>
        Your browser does not support the audio element.
    </audio>
</div>
</template>

<script>
// NOTE Component Spect---------------------------------------
// TODO Props
// [x] value => ใช้ในการรรับของผ่าน v-model

// TODO  Event
// [] Ending => เมื่อมีการ click Ending btn
// NOTE Component Spect---------------------------------------
// refs https://www.google.com/search?client=firefox-b-d&q=css+calculate+square+box+responsive+#fpstate=ive&vld=cid:9f3b84e3,vid:mVIVjhNAGog
import { mapGetters } from 'vuex'
export default {
  created () {
    this.$EventBus.$on('close-ConferenceCall', () => {
      this.ClickEndingBtn()
    })
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          token: '',
          appid: '',
          channel: '',
          uid: '',
          features: []
        }
      }
    },

    // TODO ใช้สำหรับบอกว่าเป็น HOST เพื่อใช้ในการเล่นเสียงรอสาย
    isHost: {
      type: Boolean,
      default: false
    },

    // TODO เมื่อไม่ต้องการให้ Client ทุกคนทำการ Leave เมื่อมีคนออกจากห้อง
    disableAutoLeave: {
      type: Boolean,
      default: false
    },

    // NOTE Disable Action Button --------------
    // TODO Hidden Switch moode button
    disableDisplayBtn: {
      type: Boolean,
      default: false
    },

    // TODO Hidden Record button
    disableRecordBtn: {
      type: Boolean,
      default: false
    },

    // TODO Hidden Camera button
    disableCameraBtn: {
      type: Boolean,
      default: false
    },

    // TODO Hidden Microphone button
    disableMicrophoneBtn: {
      type: Boolean,
      default: false
    },

    // TODO Hidden Shared Screen Button
    disableSharedScreenBtn: {
      type: Boolean,
      default: false
    },

    disableChatBtn: {
      type: Boolean,
      default: false
    },
    // TODO Hiddent Ending Button
    disableEndingBtn: {
      type: Boolean,
      default: false
    },
    // TODO Hiddent Ending Button
    displayInvitedToMeetingBtn: {
      type: Boolean,
      default: true
    },
    // TODO กำหนดว่า ใช้เป็นฝั่งส่งหรือรับ
    setRole: {
      type: Boolean,
      default: true
    }
    // NOTE Disable Action Button --------------
  },
  computed: {
    ...mapGetters(['storeGetUserInfo']),
    credential: {
      get () {
        // return this.value
        return {
          ...{
            token: '',
            appid: '',
            channel: '',
            uid: '',
            features: []
          },
          ...this.value
        }
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    link () {
      return `https://meet.manageai.co.th/${this.credential.channel}`
      // return `${window.location.origin}/${this.credential.channel}`
    },
    countCheckListConference () {
      const listOfselectedToMeeting = this.itemsConsult.filter(function (el) {
        return el.stateConsult === true
      })
      const arrayUserIdMeeting = []
      listOfselectedToMeeting.forEach((element) =>
        arrayUserIdMeeting.push(element.user_id)
      )
      return arrayUserIdMeeting.length
    },
    filteredList () {
      return this.itemsConsult.filter(val => {
        return val.first_name.toLowerCase().includes(this.searchItemsConsult.toLowerCase())
      })
    }
  },
  data () {
    return {
      dialog: false,
      myUid: '1', // own uid
      mainUid: '1', // uid ที่ใช้ show ในหน้าหลักเมื่อเป็น Mode List
      agora: null,
      CameraDevice: [],
      MicrophoneDevice: [],
      SoundDevice: [],
      pagePanel: true, // Page
      control: {
        camera: false,
        microphone: false,
        screen: false,
        record: false,
        display: true
      },
      users: [
        // { uid: '1', microphone: false, camera: false,screen : false ,  remoteVideoTrack: null, remoteAudioTrack: null },
        // { uid: '2', microphone: false, camera: false,screen : false remoteVideoTrack: null, remoteAudioTrack: null },
        // { uid: '3', microphone: false, camera: false, screen : falseremoteVideoTrack: null, remoteAudioTrack: null },
        // { uid: '4', microphone: false, camera: false, screen : falseremoteVideoTrack: null, remoteAudioTrack: null },
      ],

      // Grid Mode
      GridLayout: {
        row: 1,
        col: 1
      },
      AudioWaitJoin: null,
      // ListName of confernce
      itemsConsult: [],
      searchItemsConsult: '',
      dialogListConference: false,
      // check Screen shared mode
      stateSharedBtn: false,
      loadingItemsConsult: false
    }
  },
  methods: {
    async invitedToMeeting () {
      // filter ค่าที่ถูก Click
      this.dialogListConference = false
      const listOfselectedToMeeting = this.itemsConsult.filter(function (el) {
        return el.stateConsult === true
      })
      const arrayUserIdMeeting = []
      listOfselectedToMeeting.forEach((element) =>
        arrayUserIdMeeting.push(element.user_id)
      )
      await this.AlertToClient(arrayUserIdMeeting)
    },
    handleCheckboxClicks (name) {
      this.selectedNames.includes(name)
        ? this.selectedNames = this.selectedNames.filter(n => n !== name)
        : this.selectedNames.push(name)
    },
    async getListofConference () {
      this.itemsConsult = []
      this.loading = true
      this.loadingItemsConsult = true
      // this.dialogListConference = !this.dialogListConference
      this.dialogListConference = true
      const payload = {
        page: 1,
        row: 10,
        verify: 2
      }
      const res = await this.GetUserOnline(payload)
      console.log(res)
      this.loading = false
      this.loadingItemsConsult = true

      if (res.status) {
        // TODO when get data success
        this.loadingItemsConsult = false
        this.itemsConsult = res.data.data
        this.itemsConsult = this.itemsConsult.map(element => ({
          stateConsult: false,
          ...element
        }))
        this.pagination = res.data.pagination
      } else {
        // TODO when get data fail
        this.loadingItemsConsult = false
        this.antmessage.error(res.message)
      }
      // this.itemsConsult = [
      //   {
      //     user_id: 'fd145cfa-2688-4d77-b786-e412025ee89e',
      //     first_name: 'เทสอุกฤษฏ์',
      //     last_name: 'เทสอุกฤษฏ์',
      //     phone: '0123456789',
      //     gender: 'male',
      //     image: '',
      //     date_of_birth: '0001-01-01T00:00:00Z',
      //     permissions: [
      //       'ae2bbb4c-e3a6-4567-ad11-3b5c2e5b00a4'
      //     ],
      //     verify: 2,
      //     street: '',
      //     zip_code: '',
      //     city: '',
      //     country_code: '',
      //     country: '',
      //     description: '',
      //     methods: [{
      //       provider: 'local',
      //       method_id: 'f99b1135-cf77-484c-b44f-4ca2e13914a3',
      //       email: 'testukrit.te@thai.com',
      //       username: 'testukrit.te@thai.com'
      //     },
      //     {
      //       provider: 'oneid',
      //       method_id: '24198196-4e81-4bef-8f7c-21901259839a',
      //       email: 'testukrit.te@thai.com',
      //       username: 'testukrit.te@thai.com'
      //     }
      //     ],
      //     time_zone: '',
      //     name_title: 'นาย',
      //     stateConsult: false
      //   },
      //   {
      //     user_id: '15d2c65f-992d-4c7c-8434-38b0d9168dd6',
      //     first_name: 'root3',
      //     last_name: 'root3',
      //     phone: '0000000000',
      //     gender: '',
      //     image: '',
      //     date_of_birth: '2024-05-23T17:00:00Z',
      //     permissions: [
      //       '479d3f0c-1df1-48eb-b10b-ef8cb75b2a10'
      //     ],
      //     verify: 2,
      //     street: '',
      //     zip_code: '',
      //     city: '',
      //     country_code: '',
      //     country: '',
      //     description: '',
      //     methods: [{
      //       provider: 'local',
      //       method_id: '56f0f5a8-d76b-45bc-9df0-a1000c0917c6',
      //       email: 'root3@cxr.com',
      //       username: 'root3@cxr.com'
      //     }],
      //     time_zone: '',
      //     name_title: '',
      //     stateConsult: false

      //   },
      //   {
      //     user_id: 'c098e356-98be-4281-bfea-70f8060f8c18',
      //     first_name: 'วศิน',
      //     last_name: 'ทรัพย์ปริญญาพร',
      //     phone: '',
      //     gender: '',
      //     image: '',
      //     date_of_birth: '2024-05-17T03:12:11.361Z',
      //     permissions: [
      //       'ae2bbb4c-e3a6-4567-ad11-3b5c2e5b00a4'
      //     ],
      //     verify: 2,
      //     street: '',
      //     zip_code: '',
      //     city: '',
      //     country_code: '',
      //     country: '',
      //     description: '',
      //     methods: [{
      //       provider: 'local',
      //       method_id: '041510a3-6b05-4fb4-94cc-04c25f5ab961',
      //       email: '',
      //       username: ''
      //     },
      //     {
      //       provider: 'providerid',
      //       method_id: '374d9ec7-f55b-473b-8b57-7f3f1aa46cdf',
      //       email: '',
      //       username: ''
      //     }
      //     ],
      //     time_zone: '',
      //     name_title: '',
      //     stateConsult: false

      //   },
      //   {
      //     user_id: '409e4239-9d04-4544-9d6b-3765d2a575df',
      //     first_name: 'root2',
      //     last_name: 'root2',
      //     phone: '0000000000',
      //     gender: '',
      //     image: '',
      //     date_of_birth: '2024-05-08T17:00:00Z',
      //     permissions: [
      //       '479d3f0c-1df1-48eb-b10b-ef8cb75b2a10'
      //     ],
      //     verify: 2,
      //     street: '',
      //     zip_code: '',
      //     city: '',
      //     country_code: '',
      //     country: '',
      //     description: '',
      //     methods: [{
      //       provider: 'local',
      //       method_id: '36f7f933-3a14-4691-949b-f5744a57f47d',
      //       email: 'root2@cxr.com',
      //       username: 'root2@cxr.com'
      //     }],
      //     time_zone: '',
      //     name_title: '',
      //     stateConsult: false

      //   },
      //   {
      //     user_id: '97b13128-6efb-45c6-8293-a73b2632b1d7',
      //     first_name: 'bank',
      //     last_name: 'bank',
      //     phone: '0966596700',
      //     gender: '',
      //     image: '',
      //     date_of_birth: '0000-12-31T17:17:56Z',
      //     permissions: [
      //       'ae2bbb4c-e3a6-4567-ad11-3b5c2e5b00a4'
      //     ],
      //     verify: 2,
      //     street: '',
      //     zip_code: '',
      //     city: '',
      //     country_code: '',
      //     country: '',
      //     description: '',
      //     methods: [{
      //       provider: 'local',
      //       method_id: 'c50bd5e0-8b4c-4075-92fe-6a59a02660ef',
      //       email: 'bankthanakit@thai.com',
      //       username: 'bankthanakit@thai.com'
      //     },
      //     {
      //       provider: 'oneid',
      //       method_id: '6f792af1-cf85-4be4-aefa-06446585cc51',
      //       email: 'bankthanakit@thai.com',
      //       username: 'bankthanakit@thai.com'
      //     },
      //     {
      //       provider: 'providerid',
      //       method_id: 'cb681222-7cd7-4c30-aa84-7dad814f311a',
      //       email: '',
      //       username: ''
      //     }
      //     ],
      //     time_zone: '',
      //     name_title: '',
      //     stateConsult: false

      //   },
      //   {
      //     user_id: '81786082-9ff3-4029-9769-2cb4b5e9e89e',
      //     first_name: 'nattida',
      //     last_name: 'phawandee',
      //     phone: '0991312183',
      //     gender: '',
      //     image: '',
      //     date_of_birth: '0000-12-31T17:17:56Z',
      //     permissions: [
      //       '479d3f0c-1df1-48eb-b10b-ef8cb75b2a10'
      //     ],
      //     verify: 2,
      //     street: '',
      //     zip_code: '',
      //     city: '',
      //     country_code: '',
      //     country: '',
      //     description: '',
      //     methods: [{
      //       provider: 'local',
      //       method_id: 'ae38d2bf-08d8-4d3a-8e14-34d883889887',
      //       email: 'fanattida@thai.com',
      //       username: 'fanattida@thai.com'
      //     },
      //     {
      //       provider: 'oneid',
      //       method_id: '4918e9b5-1306-4189-a20f-f843c15d4e89',
      //       email: 'fanattida@thai.com',
      //       username: 'fanattida@thai.com'
      //     },
      //     {
      //       provider: 'providerid',
      //       method_id: '403e8682-69fd-4c27-8c71-1a04c8cde4ba',
      //       email: '',
      //       username: ''
      //     }
      //     ],
      //     time_zone: '',
      //     name_title: '',
      //     stateConsult: false

      //   },
      //   {
      //     user_id: '139c664a-3567-4576-93a7-d78d7b4ea941',
      //     first_name: 'จุลดิศ',
      //     last_name: 'กลิ่นลอย',
      //     phone: '0992230693',
      //     gender: 'male',
      //     image: '',
      //     date_of_birth: '1969-12-31T17:00:00Z',
      //     permissions: [],
      //     verify: 2,
      //     street: '',
      //     zip_code: '',
      //     city: '',
      //     country_code: '',
      //     country: '',
      //     description: '',
      //     methods: [{
      //       provider: 'local',
      //       method_id: '2d1790bc-9653-4c5a-b4eb-6c4753796fc9',
      //       email: '',
      //       username: ''
      //     },
      //     {
      //       provider: 'healthid',
      //       method_id: '446a7428-6165-4d28-b21a-ce721dd8fde6',
      //       email: '',
      //       username: ''
      //     }
      //     ],
      //     time_zone: '',
      //     name_title: 'นาย',
      //     stateConsult: false

      //   },
      //   {
      //     user_id: '238c5725-5961-479d-b273-72c6531c9bcd',
      //     first_name: 'ณัฐธิดา',
      //     last_name: 'ผาวันดี',
      //     phone: '0991312183',
      //     gender: 'หญิง',
      //     image: '',
      //     date_of_birth: '1969-12-31T17:00:00Z',
      //     permissions: [],
      //     verify: 2,
      //     street: '',
      //     zip_code: '',
      //     city: '',
      //     country_code: '',
      //     country: '',
      //     description: '',
      //     methods: [{
      //       provider: 'local',
      //       method_id: '24b41511-56d1-4a49-9e28-ac7baec07613',
      //       email: 'fa@gmail.com',
      //       username: 'fa@gmail.com'
      //     },
      //     {
      //       provider: 'healthid',
      //       method_id: 'be2db47e-9e27-42c5-8b44-56a2cb0d66f4',
      //       email: '',
      //       username: ''
      //     }
      //     ],
      //     time_zone: '',
      //     name_title: 'นางสาว',
      //     stateConsult: false

      //   },
      //   {
      //     user_id: '6bd58a8e-40ad-4d7f-bb8d-24c0b545fcd0',
      //     first_name: 'uxui',
      //     last_name: 'user',
      //     phone: '0000000000',
      //     gender: '',
      //     image: '',
      //     date_of_birth: '2024-02-26T17:00:00Z',
      //     permissions: [
      //       'ae2bbb4c-e3a6-4567-ad11-3b5c2e5b00a4'
      //     ],
      //     verify: 2,
      //     street: '',
      //     zip_code: '',
      //     city: '',
      //     country_code: '',
      //     country: '',
      //     description: '',
      //     methods: [{
      //       provider: 'local',
      //       method_id: '4b304418-9476-4b1b-b4c3-8bcc7ce4cd15',
      //       email: 'uxui-user@manageai.co.th',
      //       username: 'uxui-user@manageai.co.th'
      //     }],
      //     time_zone: '',
      //     name_title: '',
      //     stateConsult: false

      //   }
      // ]
    },
    // NOTE Function Calling From Control Button Group -----
    async ClickDisplayBtn (val) {
      // Cacalculate Grid Element
      if (!val.display) {
        // เมื่อใช้งานเป็นแบบ Grid Mode
        await this.calcalteGridMode()
      }
      await this.$Agora.PlayLocalTrack()
      await this.$Agora.PlayRemoteTrack(this.users)
    },

    async ClickRecordBtn (val) {
      try {
        if (val.record) {
          // NOTE เมื่อมีการ Record
          // console.log(`AGORA : start record : ${this.credential.channel}`)
          const {
            message
          } = await this.AgoraStartRecord(this.credential.channel)
          this.$notification.info({
            message: 'Start Record',
            description: message,
            placement: 'bottomRight',
            duration: 1
          })
          this.control.record = true
        } else {
          // NOTE เมื่อไม่มีการ Record
          const {
            message
          } = await this.AgoraStopRecord(this.credential.channel)
          this.$notification.info({
            message: 'Stop Record',
            description: message,
            placement: 'bottomRight',
            duration: 1
          })
          this.control.record = false
        }
      } catch (err) {
        this.$notification.error({
          message: 'Error',
          description: err.message,
          placement: 'bottomRight'
        })
      }
    },

    async ClickCameraBtn (val) {
      // NOTE เป็น Function ที่ใช้ในการ เปิด/ปิด กล้อง
      const idxs = await Promise.all(this.users.map((e) => e.uid))
      const idx = idxs.indexOf(this.myUid)
      if (idx >= 0) {
        this.users[idx].camera = val.camera
        this.$Agora.SetMuteCamera(!val.camera)
        // this.$Agora.SetMuteCamera1(!val.camera)
      }
    },

    async ClickMicrophoneBtn (val) {
      // NOTE เป็น Function ที่ใช้ในการ เปิด/ปิด ไมโครโฟน
      const idxs = await Promise.all(this.users.map((e) => e.uid))
      const idx = idxs.indexOf(this.myUid)
      if (idx >= 0) {
        this.users[idx].microphone = val.microphone
        this.$Agora.SetMuteMicrophone(!val.microphone)
      }
    },

    // async ClickSharedScreenBtn (val) {
    //   console.log('ClickSharedScreenBtn')
    //   console.log(val)
    //   const idxs = await Promise.all(this.users.map((e) => e.uid))
    //   const idx = idxs.indexOf(this.myUid)
    //   if (idx >= 0) {
    //     this.users[idx].screen = val.screen
    //     this.$Agora.SetMuteScreen(!val.screen)
    //   }
    // },

    async ClickSharedScreenBtn (val) {
      // if val.screen = false
      if (!this.stateSharedBtn) {
        const idxs = await Promise.all(this.users.map((e) => e.uid))
        const idx = idxs.indexOf(this.myUid)
        if (idx >= 0) {
          this.users[idx].screen = val.screen
          // this.$Agora.SetMuteScreen(val.screen)
          const res = await this.$Agora.handleScreenShare(val.screen)
          if (res) {
            // ว่าเลือกจอ
            this.stateSharedBtn = true
          } else {
            // กดไม่เลือกจอ
            this.stateSharedBtn = false
          }
        }
        // เนื่องจาก ทำการกดแล้ว แชร์จออยู่ จึงเปลี่ยนเป็น true
        // this.stateSharedBtn = true
      } else {
        // กรณี shared screen อยู่แล้วอยากปิดจอ
        const idxs = await Promise.all(this.users.map((e) => e.uid))
        const idx = idxs.indexOf(this.myUid)
        if (idx >= 0) {
          this.users[idx].screen = val.screen
          this.$Agora.handleScreenShare(true)
        }
        this.stateSharedBtn = false
      }
    },

    async ClickEndingBtn (channel) {
      // try {
      //   // NOTE stop sound --------------
      if (this.AudioWaitJoin) {
        this.AudioWaitJoin.pause()
      }
      //   // NOTE stop sound --------------
      //   const { message } = await this.AgoraEndingCalling(channel)
      //   this.$notification.info({
      //     message: 'Stop Record',
      //     description: message,
      //     placement: 'bottomRight',
      //     duration: 2
      //   })
      // } catch (err) {
      //   this.$notification.error({
      //     message: 'Error',
      //     description: err.message,
      //     placement: 'bottomRight',
      //     duration: 2
      //   })
      // }

      // Reset Variable
      this.myUid = null
      this.mainUid = null
      this.users = []
      this.pagePanel = true
      this.control = {
        camera: false,
        microphone: false,
        record: false,
        display: true,
        screen: false
      }
      await this.$Agora.Leave()
      await this.$emit('end', '')
    },
    // NOTE Function Calling From Control Button Group ------
    async copyText () {
      // Get the text field
      const textToCopy = document.getElementById('copy-shared-url')

      // Select the text field
      await textToCopy.select()
      await textToCopy.setSelectionRange(0, 99999) // For mobile devices

      // Copy the text inside the text field
      await navigator.clipboard.writeText(textToCopy.value)
    },

    async clickJoin () {
      // # initial Agora
      await this.$Agora
      await this.$Agora.New()

      // # initial Variable
      this.myUid = this.credential.uid
      this.mainUid = this.credential.uid
      this.AudioWaitJoin = document.getElementById('myAudio')
      this.AudioWaitJoin.loop = true
      this.AudioWaitJoin.pause()

      const userConfig = {
        uid: this.myUid,
        microphone: true,
        camera: true
      }
      this.users.push(userConfig)
      this.pagePanel = false
      this.control.camera = userConfig.camera
      this.control.volume = 0.2
      this.control.microphone = userConfig.microphone
      // # Start Event
      this.$Agora.Event().on('user-joined', async (evt) => {
        this.users.push({
          uid: evt.uid.toString(),
          microphone: false,
          camera: false,
          screen: false,
          remoteAudioTrack: null,
          remoteVideoTrack: null
        }) // ? Default Our Player
        this.calcalteGridMode()
        this.clickSwapUser(evt.uid.toString())
        // this.$message.info('user is join')

        // NOTE stop sound --------------
        this.AudioWaitJoin.pause()
        // NOTE stop sound --------------
      })
      this.$Agora.Event().on('track-ended', (val) => {
        this.stateSharedBtn = val
        this.ClickSharedScreenBtn()
      })
      this.$Agora.Event().on('user-published', async (user, mediaType) => {
        const idxs = await Promise.all(this.users.map((e) => e.uid))
        const idx = idxs.indexOf(user.uid)
        if (idx >= 0) {
          // this.$message.info(`user is published : ${mediaType}`)
          // TODO ต้อง Track Audio and vedio ด้วย
          if (mediaType === 'video') {
            this.users[idx].remoteVideoTrack = await user.videoTrack
            if (this.users[idx].remoteVideoTrack != null) {
              await this.users[idx].remoteVideoTrack.play(`player-${user.uid}`)
              this.users[idx].camera = true
            }
          }
          if (mediaType === 'audio') {
            this.users[idx].remoteAudioTrack = await user.audioTrack
            if (this.users[idx].remoteAudioTrack != null) {
              this.users[idx].remoteAudioTrack.play()
              this.users[idx].microphone = true
            }
          }
        }
      })

      this.$Agora.Event().on('user-unpublished', async (user, mediaType) => {
        const idxs = await Promise.all(this.users.map((e) => e.uid))
        const idx = idxs.indexOf(user.uid)
        if (idx >= 0) {
          // this.$message.info(`user is unpublished : ${mediaType}`)
          if (mediaType === 'video') {
            this.users[idx].remoteVideoTrack = null
            this.users[idx].camera = false
          }
          if (mediaType === 'audio') {
            this.users[idx].remoteAudioTrack = null
            this.users[idx].microphone = false
          }
        }
      })

      this.$Agora.Event().on('user-left', async (user) => {
        const idxs = await Promise.all(this.users.map((e) => e.uid))
        const idx = idxs.indexOf(user.uid)
        if (idx >= 0) {
          // this.$message.info(`user left conference`)
          this.users.splice(idx, 1)
          this.clickSwapUser(this.myUid) // แก้ไขปัญหาเมื่อ myUid อนยู่ใน User List ใหท้มาอยู่ใน Main User
          this.calcalteGridMode()

          // FIX 2023-03-02 เก็บข้อมูล userAgent ของ Browser ที่ใช้งาน Conference------
          console.log(navigator.userAgent)
          // this.logging(user.uid, navigator.userAgent, 'exit', 'exit')
          // FIX ----------------------------------------------------------------

          // TODO เมื่อมี user ออกจาก channel ทำการ leave ทุกคนออกจาก cannel
          console.log(this.disableAutoLeave)
          if (!this.disableAutoLeave) {
            this.ClickEndingBtn(this.channel)
            this.$notification.info({
              message: 'จบการสนทนา',
              description: 'สิ้นสุดการสนทนากับปลายทาง',
              placement: 'bottomRight'
            })
          }
        }
      })

      // console.log(this.credential)
      // # Start Join
      await this.$Agora.Join(this.credential)
      await this.$Agora.SetMuteMicrophone(!userConfig.microphone)
      await this.$Agora.SetMuteCamera(!userConfig.camera)

      // NOTE play sound --------------
      if (this.isHost) this.AudioWaitJoin.play()
      // NOTE play sound --------------
    },
    // async clickBtnCamera (status) {
    //   const idxs = await Promise.all(this.users.map((e) => e.uid))
    //   const idx = idxs.indexOf(this.myUid)
    //   if (idx >= 0) {
    //     this.users[idx].camera = status
    //     this.$Agora.SetMuteCamera(!status)
    //     // this.$message.info(`${status ? 'unmute' : 'mute'} camera`)
    //   }
    // },
    // async clickBtnMicrophone(status) {
    //   const idxs = await Promise.all(this.users.map((e) => e.uid))
    //   const idx = idxs.indexOf(this.myUid)
    //   if (idx >= 0) {
    //     this.users[idx].microphone = status
    //     this.$Agora.SetMuteMicrophone(!status)
    //     // this.$message.info(`${status ? 'unmute' : 'mute'} microphone`)
    //   }
    // },

    async clickBtnSharedScreen (status) {
      if (status) {
        // TODO เมื่อมีการ Shared Screen
        this.$Agora.StartScreenSharing()
      } else {
        // TODO เมื่อหยุดการ Shared Screen
        this.$Agora.StopScreenSharing()
      }
    },

    clickSwapUser (uid) {
      this.mainUid = uid
      this.$Agora.PlayLocalTrack()
      this.$Agora.PlayRemoteTrack(this.users)
    },

    calcalteGridMode () {
      const w = window.innerWidth

      switch (this.users.length) {
        case 1:
          this.GridLayout.row = 1
          this.GridLayout.col = 1
          break
        case 2:
          if (w >= 800) {
            // Desktop Mode
            this.GridLayout.row = 1
            this.GridLayout.col = 2
          } else {
            // Mobile Mode
            this.GridLayout.row = 2
            this.GridLayout.col = 1
          }
          break
        case 3:
          if (w >= 800) {
            // Desktop Mode
            this.GridLayout.row = 1
            this.GridLayout.col = 3
          } else {
            // Mobile Mode
            this.GridLayout.row = 2
            this.GridLayout.col = 2
          }
          break
        case 4:
          if (w >= 800) {
            // Desktop Mode
            this.GridLayout.row = 2
            this.GridLayout.col = 2
          } else {
            // Mobile Mode
            this.GridLayout.row = 2
            this.GridLayout.col = 2
          }
          break

        default:
          this.GridLayout.row = this.users.length
          this.GridLayout.col = this.users.length
          break
      }
    },

    async StopRecord (channel, webhook = true) {
      try {
        // Remove Css To Blink Button
        // this.$message.success('Stop Record', 1)
        // Stop Record
        console.log(`AGORA : stop record : ${channel}`)
        // const options = {
        //   url: `${process.env.VUE_APP_API}/api/v1/record/stop`,
        //   method: 'post',
        //   data: {
        //     channel_name: channel,
        //     webhook: webhook,
        //   },
        // }
        // this.axios(options)
        console.log(webhook)
        const {
          message
        } = await this.AgoraStopRecord(channel)
        this.$notification.info({
          message: 'Stop Record',
          description: message,
          placement: 'bottomRight',
          duration: 2
        })
        this.control.record = false
      } catch (err) {
        this.$notification.error({
          message: 'Error',
          description: err.message,
          placement: 'bottomRight'
        })
      }
    },
    async StartRecord (channel) {
      // this.$message.success('Start Record', 1)
      // Add Css To Blink Button
      // console.log('AGORA : start record :', channel)
      // // Start Record
      // const options = {
      //   url: `${process.env.VUE_APP_API}/api/v1/record/start`,
      //   method: 'post',
      //   data: {
      //     channel_name: channel,
      //   },
      // }
      // this.axios(options)
      try {
        const {
          message
        } = await this.AgoraStartRecord(channel)
        this.$notification.info({
          message: 'Start Record',
          description: message,
          placement: 'bottomRight',
          duration: 2
        })
        this.control.record = true
      } catch (err) {
        this.$notification.error({
          message: 'Error',
          description: err.message,
          placement: 'bottomRight'
        })
      }
    },
    Close () {
      // TODO Reset Value
      this.dialogListConference = false
    }
  }
  // watch: {
  //   'control.microphone'(newValue) {
  //     // เมื่อมีการกดปุ่ม michrophone
  //     this.clickBtnMicrophone(newValue)
  //   },
  //   'control.camera'(newValue) {
  //     // เมื่อมีการกดปุ่ม camera
  //     this.clickBtnCamera(newValue)
  //   },
  //   'control.record'(newValue) {
  //     // เมื่อมีการกดปุ่ม record
  //     if (newValue) this.StartRecord(this.credential.channel)
  //     else this.StopRecord(this.credential.channel, false)
  //   },
  //   'control.display'() {
  //     this.$Agora.PlayLocalTrack()
  //     this.$Agora.PlayRemoteTrack(this.users)
  //   },
  // },
}
</script>

<style lang="scss" scoped>
.main-page-calling {
    height: 100%;
    width: 100%;
    // padding: 0;
    // margin: 0;
    padding: 5px;
    // display: block;
    // background: #2f2f2f;
}

// .layout {
//   width: 100%;
//   height: 100%;
//   padding: 0;
//   margin: 0;
// }
.panel-layout {
    background: white;
    padding: 10px !important;
}

.layout-calling {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: relative;
    top: 0;
    left: 0;

}

// Layout Grid ---------------------
.layout-user-grid {
    width: 100%;
    height: 100%;
    position: relative;
    left: 0;
    z-index: 1;
}

// .layout-user-grid.list {
//   // เมื่อเป็น Mode List จะทำการ เว้นระยะของ List User
//   // top: 144px;
//   // height: 70%;
//   // background: lightblue;

//   // height: calc(100% - 144px - 100px);
// }

// .layout-user-grid.grid {
//   // เมื่อเป็น Mode Grid จะทำการ Close List User
//   top: 0;
//   height: calc(100% - 100px);
//   background: lightgoldenrodyellow;
// }

.user-grid-display {
    height: 40%;
    display: grid;
    justify-content: center;
    justify-items: center;
    align-items: center;
    // grid-template-columns: repeat(1, 1fr);
    // grid-template-rows: repeat(1, 1fr);
}

.layout-user-grid .user-grid-display .items {
    // background: purple;
    // position: relative;
    // max-width: calc(100vh - 150px - 100px);
    // // max-width: calc(100% - 150px - 100px);
    width: 100%;
    height: 100%;
    border-radius: 10px;
}

// .layout-user-grid .user-grid .items::after {
// content: '';
// background: red;
// display: block;
// padding-top: 100%;
// }

// Layout List ---------------------
.layout-user-list {
    padding: 3px;
    // background: gray;
    width: 100%;
    // height:30%;
    // max-height: fit-content;
    overflow-y: scroll;
    padding: 2px;
    position: relative;
    // top: 0;
    // left: 0;
    z-index: 1;
}

.layout-user-list-display {
    height: 30%;
}

.layout-user-list-non-display {
    height: 80%;
}

.layout-user-list .user-list {
    display: flex;
    // flex-direction: row-reverse;
    padding: 3px;
    // background: orange;
    justify-content: space-between;
    // overflow-x: auto;
    // overflow-y: scroll;
    flex-wrap: wrap;
}

//ขนาด user list เล็ก
.layout-user-list .user-list .items {
    position: relative;
    // width: 100%;
    // min-width: 140px;
    // max-width: 140px;
    // width: 46%;
    border-radius: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
}

.layout-user-list .user-list .items::after {
    content: '';
    display: block;
    padding-top: 100%;

}

.layout-user-list .user-list .item-content {
    background: purple;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 10px;
    background: #fffcfc;
    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16);
    border-radius: 12px;
    padding-bottom: 40px;
}

// -------------------------------
.layout-users-row {
    // height: 100%;
    margin: 0px;
}

.layout-users-col {
    height: 100%;
    padding: 1px;
}

// }
.layout-control {
    width: 100%;
    // height: 100%;
    bottom: 0;
    // top: 0;
    position: absolute;
    z-index: 1;
    // background: green;
}

// NOTE CHAT
::v-deep .chat-layout {
    padding: 0;
    margin: 0;
    overflow: hidden;
}

.chat-layout-card {
    padding: 0;
    margin: 0;
    overflow: hidden;
    height: 70vh;
    min-width: 300px;
}

.chat-iframe {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    /* Hide scrollbars */
}

.display-state-user-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
}

.state-btn-user-list {
    /* Auto layout */

    display: flex;
    justify-content: center;
    border: 1px solid #e5e5e5;

    // padding: 6px;
    // margin-right: 5px;
    // margin-left: 5px;
    width: 32px;
    height: 32px;
    // width: 20%;
    // height: 20%;
    background: rgba(51, 51, 51, 0.5);
    border-radius: 32px;

}

/* scrollbar */
::v-deep ::-webkit-scrollbar {
    display: block;
    width: 8px;
}

/* Track */
/* ::v-deep ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
} */

/* Handle */
::v-deep ::-webkit-scrollbar-thumb {
    /* background: red; */
    background: #c3c8d0d0;
    border-radius: 8px;
}

/* Handle on hover */
::v-deep ::-webkit-scrollbar-thumb:hover {
    background: #acb0b8d0;
}

// ส่วนของ dialogListConference
.consult-user {
    /* Auto layout */
    display: flex;
    align-items: center;
    // flex-direction: row;
    justify-content: space-between;
    // align-items: flex-start;
    padding: 10px 12px;
    // gap: 16px;
    // isolation: isolate;

    width: 100%;
    // height: 100%;
    height: 86px;
    // max-height: 86px;
    // max-width: 384px;
    margin-top: 10px;
    margin-bottom: 10px;

    /* 01-Cards Pressed button */
    box-sizing: border-box;
    border: 1px solid #E6E6E6;
    border-radius: 12px;
    background: #FFFFFF;

}

.layout-dialog-conference {
    // height: 100%;
    // max-width: 600px;
    // background: lightgreen;
    overflow-y: hidden;
    // border-radius: 12px;
}

.list-content-card {
    // background: red;
    max-height: 400px;
    // min-height: 200px;
    width: 100%;
    overflow-y: scroll;
}

.size-image-icon {
    width: 32px;
    height: 32px;
    margin-right: 8px;
}

.no-user-online {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    color: #989898;
    padding: 5px;
}
.btn-invited-meeting{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  width: 100%;
  max-width: 120px;
  height: 40px;
  font-weight: 500;
  font-size: 16px;
  color: #fffcfc;
  background: #20409C;
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16);
  border-radius: 20px;
}
.btn-invited-meeting-close
{
/* Button */

box-sizing: border-box;

/* Auto layout */
display: flex;
flex-direction: row;
align-items: center;
padding: 8px 16px;
gap: 8px;
  width: 100%;
  max-width: 120px;
height: 40px;
color: #20409C;
border: 1px solid #20409C;
border-radius: 20px;
}
.text-consult{
  font-weight: 600;
  font-size: 14px;
  // margin-left: 10px;
  margin-left: 20%;

  color: #20409C;
}
.gap-control-btn{
  /* margin-right: 4px;
  margin-left: 4px;
   */
  //  margin-left: 4px;
  margin-right: 4px;
   padding-right: 4px;
   padding-left: 4px;

   /* background: red; */
}
.search-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  position: relative;
  padding: 3px;
  // background: red;
}
.search-input {
  width: 100%;
  // height: 100%;
  max-height: 40px;
  padding: 12px 20px;
  font-size: 14px;
  border: 1px solid #E6E6E6;
  border-radius: 32px;
}
.search-input:focus {
  outline: none;  // box-shadow: 0px 1px 1px rgba(32, 33, 36, 0.1);
}
</style>
